import Vue from 'vue'
import { IContentProceduresGrid } from '@/modules/configurationModule/detail/samples/procedures/Procedures.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ProceduresConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<IContentProceduresGrid>> {
        const response = await this.axios.put(`/configuration/procedures`, filterModel, { params })
        return response.data
    }
    async patchProceduresBatch(request: IContentProceduresGrid[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/procedures/batch`, request)
        return response.data
    }
    async createProcedure(request: IContentProceduresGrid): Promise<IContentProceduresGrid> {
        const response = await this.axios.post(`/configuration/procedures`, request)
        return response.data
    }
    async deleteProcedureBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/procedures/batch`, { data: request })
        return response.data
    }
}

export const proceduresConfigurationServices = new ProceduresConfigurationServices()
